import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/utils/auth";
import { useCurrentUserFromFirestore } from "@/utils/useCurrentUserFromFirestore.js";

const ADMIN_UID = "U4mlColHvRdwiA0q6jU13cuMExB3";

const ActiveUserRoute = () => {
  const { user, loading } = useAuth();
  // Accounts approved under the old moderation flow (status "active") are
  // grandfathered in so existing users aren't locked out; anyone else must
  // verify their email address instead.
  const { firestoreUser, loading: firestoreLoading } = useCurrentUserFromFirestore();

  if (loading || (user && firestoreLoading))
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "18px",
          fontWeight: "bold",
        }}
      >
        Loading...
      </div>
    );

  if (!user) return <Navigate to="/auth/sign-in" replace />;

  if (user.uid === ADMIN_UID) return <Navigate to="/admin" replace />;

  const isGrandfathered = firestoreUser?.status === "active";
  if (!user.emailVerified && !isGrandfathered) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Outlet />;
};

export default ActiveUserRoute;
